export default "__VITE_ASSET__Dg_Igvo1__"